import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import TeamListLayer from '../components/teams/TeamListLayer'

export const TeamListPage = () => {
  return (
    <MasterLayout>
        <TeamListLayer/>
    </MasterLayout>
  )
}
